import type { AxiosRequestConfig } from 'axios';
import api from '@/lib/api';

export interface SshKeyDto {
  id: number;
  name: string;
}

/**
 * Fetch SSH keys for a Hetzner project by token.
 * Backend endpoint: POST /rest/provider/hetzner/sshkeys
 */
export async function getHetznerSshKeys(
  hetznerAuthToken: string,
  config: AxiosRequestConfig = {}
): Promise<SshKeyDto[]> {
  const { data } = await api.post<SshKeyDto[]>(
    'provider/hetzner/sshkeys',
    { hetznerAuthToken },
    config
  );
  return Array.isArray(data) ? data : [];
}
